import { render, staticRenderFns } from "./FavoriteRecords.vue?vue&type=template&id=23b524e9&scoped=true"
import script from "./FavoriteRecords.vue?vue&type=script&lang=js"
export * from "./FavoriteRecords.vue?vue&type=script&lang=js"
import style0 from "./FavoriteRecords.vue?vue&type=style&index=0&id=23b524e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b524e9",
  null
  
)

export default component.exports